import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const PHONE = "0212 812 02 95";
const PHONE_TEL = "+902128120295";
const WHATSAPP_NUMBER = "902123333333";

const FloatingButtons = () => {
  const { t } = useLanguage();
  const whatsappMsg = encodeURIComponent(t("floating.whatsappMsg"));

  return (
    <div
      className="fixed z-50 right-4 bottom-20 sm:right-6 sm:bottom-6 flex flex-col gap-3"
      data-testid="floating-actions"
    >
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappMsg}`}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-emerald-500/30 hover:scale-105 transition-transform"
        aria-label={t("floating.whatsappAria")}
        data-testid="floating-whatsapp-button"
      >
        <span className="pulse-ring text-[#25D366]" />
        <MessageCircle size={24} strokeWidth={2} />
        <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-slate-900 text-white text-xs px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity hidden sm:block">
          WhatsApp
        </span>
      </a>
      <a
        href={`tel:${PHONE_TEL}`}
        className="group relative flex items-center justify-center h-14 w-14 rounded-full bg-teal-600 text-white shadow-lg shadow-teal-600/30 hover:scale-105 transition-transform"
        aria-label={`${t("floating.phoneAria")}: ${PHONE}`}
        data-testid="floating-phone-button"
      >
        <span className="pulse-ring text-teal-600" />
        <Phone size={22} strokeWidth={2} />
        <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-slate-900 text-white text-xs px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity hidden sm:block">
          {PHONE}
        </span>
      </a>
    </div>
  );
};

export default FloatingButtons;
